// extracted by mini-css-extract-plugin
export default {"overlay":"iy-z","bodyOpen":"jy-z","content":"ky-z","header":"ly-z","close":"my-z","closeNoHeading":"ny-z"};